import { dynListTypes, gEnums, listTypes } from 'global/enums/globalEnums'
import { listHelpers, listList } from 'global/lists/lists'
import React, { useCallback, useContext, useMemo } from 'react'
import _ from 'lodash'
import { ParentContext } from '../../ParentContext'
import { SquaresContext } from 'global/wrappers/SquaresWrapper'
import { manifestSizes } from 'global/components/imaging/createManifestIcons'
import { _timeZones } from 'global/common/dateFormatting'
import { appFormTypes, appUserFormTypes } from 'global/enums/appFormTypes'
import { _projectAppNames, _projectAppNamesNonDev } from 'project/appConfiguration'
import { useAppUserAccess } from '../useAppUserAccess'

const showLogs = false

const _phoneExceptions = ['displayPhoneNumber', 'allowPhoneNumber', 'hidePhoneNumber', 'hidePhoneNumberFromApp', 'useClientProfilePhoneNumber']

export const useDynamicListOptions = ({
  currentCollectionPropList = null,
  currentViProps = null,
  groupItems = null,
  localData = null,
} = {}) => {

  const appUserAccess = useAppUserAccess()
  const { isDeveloper } = appUserAccess ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state, eventInfo_state, storage_state } = states ?? {}
  const { appDataDocuments } = eventInfo_state ?? {}
  const { aps_global, aps_viewItems, aps_appUserSettings, viewItemsList, allPropsList } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUserCollection, appUserViewTypeProp } = aps_appUserSettings ?? {}
  const viewItem_appUser = appUserCollection && aps_viewItems && aps_viewItems[appUserCollection] ? aps_viewItems[appUserCollection] : {}
  const { props: props_appUser } = viewItem_appUser ?? {}
  const { appComponents } = aps_global ?? {}
  const { componentContent } = appComponents ?? {}
  const c = viewItemsList ? [...viewItemsList] : []
  c.push('clients')

  const squaresContext = useContext(SquaresContext)
  const { squares_state } = squaresContext ?? {}
  const { view, allGroups } = squares_state ?? {}

  const _latestView = getActualView(view, allGroups, appDataDocuments)
  const currentViPropList = aps_viewItems?.[_latestView]?.props

  const dynOptions = useMemo(() => {

    const opts_appDdis = {}
    const opts_dynamic = []
    const opts_listTypes = {}

    _.forEach(groupItems, (gi, giKey) => {
      if (appDataDocuments?.[giKey]) {
        opts_appDdis[giKey] = listHelpers.listStatic(appDataDocuments?.[giKey])
      }
    })

    // const dl_optz = []

    // const listTypeProps = _.filter(groupItems, function (vp) {
    //   if (vp.data && vp.data.listType) {
    //     return vp.data.listType
    //   }
    // });

    const currentDynListProps = _.filter(groupItems, function (vp) {
      if (vp.data && vp.data.listType && dynListTypes[vp.data.listType]) {
        return vp.data.listType
      }
    });

    const listTypeKeys = _.uniq(_.compact(_.map(groupItems, 'data.listType')));

    // add some additional keys
    listTypeKeys.push('itemStatusType')

    // get only the groupItems that have data.listType 
    currentDynListProps.forEach(itemProp => {

      try {
        const { data } = itemProp ?? {}

        const {
          listType: dynListType,
          listFrom, staticView: staticView_data,
          staticListProp: staticListProp_data,
          formItemType
        } = data ?? {}

        const { staticList } = staticListProp_data ?? {}

        let isNameSelect;

        switch (formItemType) {
          case gEnums.formItemTypes.nameSelect:
            isNameSelect = true
            break;
          default:
            isNameSelect = false
          // nothing
        }

        // list type can be for either listTypes OR dynListTypes

        switch (dynListType) {

          case dynListTypes.activePropList:
            opts_dynamic[dynListType] = currentViPropList ? listHelpers.listListO(currentViPropList) : null
            if (currentViProps) {
              opts_dynamic[dynListType] = listHelpers.listSimple(currentViProps)
            }
            break;

          case dynListTypes.activePropsList:
            opts_dynamic[dynListType] = currentViPropList ? listHelpers.listListO(currentViPropList) : null
            if (currentViProps) {
              opts_dynamic[dynListType] = listHelpers.listSimple(currentViProps)
            }
            break;

          case dynListTypes.activeAppUserViewProps:
            const _props_appUser = props_appUser ? { ...props_appUser } : {}
            Object.keys(_props_appUser).forEach(key => {
              if (key.startsWith('_')) { delete _props_appUser[key] }
            })
            opts_dynamic[dynListType] = _props_appUser ? listHelpers.listListO(_props_appUser) : null
            break;

          case dynListTypes.activeViPropList:
            if (localData && listFrom && localData[listFrom]) {
              const listFromValue = localData[listFrom]
              if (appDataDocuments?.[listFromValue]) {
                const addValues = appDataDocuments[listFromValue]
                opts_dynamic[dynListType] = listHelpers.listStatic(addValues)
              }
            } else if (aps_viewItems) {
              opts_dynamic[dynListType] = listHelpers.listListO(aps_viewItems)
            }
            // opts_dynamic[dynListTypes.activePropList] = opts_dynamic[dynListType]
            // ola[dynListType] = listList(viewItemsList)
            break;

          case dynListTypes.allPropList:
            opts_dynamic[dynListType] = listHelpers.listList(allPropsList)
            break;

          case dynListTypes.activeViList:
            opts_dynamic[dynListType] = listHelpers.listList(viewItemsList)
            break;

          case dynListTypes.activeViPropList2:
            if (localData && listFrom && localData[listFrom]) {
              const listFromValue = localData[listFrom]
              if (appDataDocuments?.[listFromValue]) {
                const staticValues = appDataDocuments[listFromValue]
                opts_dynamic[dynListType] = listHelpers.listStatic(staticValues)
              }
            }
            break;

          case dynListTypes.activeStaticViewsList:
            if (staticListProp_data && appDataDocuments && appDataDocuments[staticList]) {
              opts_dynamic[dynListType] = listHelpers.listStatic(appDataDocuments[staticList])
            } else {
              opts_dynamic[dynListType] = listHelpers.listListO(appDataDocuments)
            }
            break;

          case dynListTypes.appUserViewTypeProps:
            if (appDataDocuments && appDataDocuments[appUserViewTypeProp]) {
              opts_dynamic[dynListType] = listHelpers.listStatic(appDataDocuments[appUserViewTypeProp], appUserViewTypeProp)
            }
            break;

          case dynListTypes.activeCollectionPropList:
            opts_dynamic[dynListType] = currentCollectionPropList ? listHelpers.listListO(currentCollectionPropList) : null
            break;

          // case dynListTypes.appPdfs:
          //   console.log('storage_state', storage_state)
          //   if (storage_state?.appStorageUrlFiles?.pdf) {
          //     dl_opts[dynListType] = listHelpers.listListO(storage_state?.appStorageUrlFiles?.pdf)
          //   } else {
          //     dl_opts[dynListType] = {}
          //   }
          //   break;

          // case dynListTypes.activeComponentList:
          //   dl_opts[dynListType] = listHelpers.listListI(componentContent)
          //   break;



          // case dynListTypes.itemPdf:
          //   if (storage_state && storage_state.appStorageUrlFiles && storage_state.appStorageUrlFiles.pdf) {
          //     dl_opts[dynListType] = listHelpers.listListO(storage_state.appStorageUrlFiles.pdf)
          //   } else {
          //     dl_opts[dynListType] = {}
          //   }
          //   break;

          // case dynListTypes.appUserViewTypeProps:
          //   if (appDataDocuments && appDataDocuments[appUserViewTypeProp]) {
          //     dl_opts[dynListType] = listHelpers.listStatic(appDataDocuments[appUserViewTypeProp], appUserViewTypeProp)
          //   }
          //   break;

          // case dynListTypes.activeAppUserViewProps:
          //   const _props_appUser = props_appUser ? { ...props_appUser } : {}
          //   Object.keys(_props_appUser).forEach(key => {
          //     if (key.startsWith('_')) { delete _props_appUser[key] }
          //   })
          //   dl_opts[dynListType] = _props_appUser ? listHelpers.listListO(_props_appUser) : null
          //   break;

          // case dynListTypes.activeAppUserView:
          //   dl_opts[dynListType] = additionalAppUserViewTypeProps ? listHelpers.listList([...additionalAppUserViewTypeProps, appUserCollection]) : listHelpers.listList([appUserCollection])
          //   break;

          // case dynListTypes.activeCollectionPropList:
          //   dl_opts[dynListType] = currentCollectionPropList ? listHelpers.listListO(currentCollectionPropList) : null
          //   break;

          // case dynListTypes.activePropList:
          //   dl_opts[dynListType] = currentViPropList ? listHelpers.listListO(currentViPropList) : null
          //   break;

          // case dynListTypes.activePropsList:
          //   dl_opts[dynListType] = currentViPropList ? listHelpers.listListO(currentViPropList) : null
          //   break;

          // case dynListTypes.activeSectionList:
          //   dl_opts[dynListType] = currentViPropList ? listHelpers.listListO(sectionsFromProps(currentViPropList)) : null
          //   break;

          // case dynListTypes.activeAppUserStaticView:
          //   if (appDataDocuments && appDataDocuments[appUserCollection]) {
          //     dl_opts[dynListType] = listHelpers.listStatic(appDataDocuments[appUserCollection], appUserCollection)
          //   }
          //   break;

          // case dynListTypes.activeStaticView:
          //   if (appDataDocuments && appDataDocuments[staticView_data]) {
          //     dl_opts[dynListType] = listHelpers.listStatic(appDataDocuments[staticView_data], staticView_data, null, isNameSelect, staticView_data)
          //   }
          //   break;

          // case dynListTypes.activeStaticViewsList:
          //   if (staticListProp_data && appDataDocuments && appDataDocuments[staticList]) {
          //     dl_opts[dynListType] = listHelpers.listStatic(appDataDocuments[staticList])
          //   } else {
          //     dl_opts[dynListType] = listHelpers.listListO(appDataDocuments)
          //   }
          //   break;

          // case dynListTypes.activeViList:
          //   dl_opts[dynListType] = listHelpers.listList(viewItemsList)
          //   break;

          // case dynListTypes.activeViPropList:
          //   if (data_combined && listFrom && data_combined[listFrom]) {
          //     const listFromValue = data_combined[listFrom]
          //     if (appDataDocuments && appDataDocuments[listFromValue]) {
          //       const staticValues = appDataDocuments[listFromValue]
          //       dl_opts[dynListType] = listHelpers.listStatic(staticValues)
          //     }
          //   } else if (aps_viewItems) {
          //     dl_opts[dynListType] = listHelpers.listListO(aps_viewItems)
          //   }
          //   // ola[dynListType] = listList(viewItemsList)
          //   break;

          // case dynListTypes.activeViPropList2:
          //   if (data_combined && listFrom && data_combined[listFrom]) {
          //     const listFromValue = data_combined[listFrom]
          //     if (appDataDocuments && appDataDocuments[listFromValue]) {
          //       const staticValues = appDataDocuments[listFromValue]
          //       dl_opts[dynListType] = listHelpers.listStatic(staticValues)
          //     }
          //   }
          //   // ola[dynListType] = listList(viewItemsList)
          //   break;

          // case dynListTypes.activeViListExceptSelf:
          //   dl_opts[dynListType] = listHelpers.listList(viewItemsList, null, updateProps && updateProps.vit)
          //   break;

          // case dynListTypes.activeViListPlusClient:
          //   dl_opts[dynListType] = listHelpers.listList(c.sort())
          //   break;

          // case dynListTypes.allPropList:
          //   dl_opts[dynListType] = listHelpers.listList(allPropsList)
          //   break;

          // case dynListTypes.appAddActions:
          //   dl_opts[dynListType] = listHelpers.listList(availableAddTypes)
          //   break;

          // case dynListTypes.appActions:
          //   dl_opts[dynListType] = listHelpers.listList(availableSubActionTypes)
          //   break;

          // case dynListTypes.settingsHandlers:
          //   dl_opts[dynListType] = listHelpers.listList(getAllHandlers(handlers))
          //   break;

          // case dynListTypes.settingsHandlerRts:
          //   if (data_combined && listFrom && data_combined[listFrom]) {
          //     const listFromValue = data_combined[listFrom]
          //     dl_opts[dynListType] = listHelpers.listList(getHandler(handlers, listFromValue))
          //   }
          //   break;

          default:
            break;
        }
      } catch (error) {

      }

    })

    const opts_combined = { ...opts_dynamic, ...opts_appDdis, ...opts_listTypes }

    if (showLogs) {
      console.group('useDynamicListOptions')
      console.log('listTypeKeys', listTypeKeys)
      console.log('groupItems', groupItems)
      // console.log('--opts_dynamic', opts_dynamic)
      // console.log('--opts_appDdis', opts_appDdis)
      console.log('--opts_listTypes', opts_listTypes)
      console.log('opts_combined', opts_combined)
      console.groupEnd()
    }

    return opts_combined

  }, [currentViPropList, currentViProps, localData])

  const getDynOption = useCallback((itemProp, data_localForm, view_ss, squares_state) => {

    let _propOptions;

    ammendFormItemType(itemProp)

    const { allGroups } = squares_state ?? {}

    const { data, key, prop } = itemProp ?? {}
    let { formItemType, listType, listFrom } = data ?? {}

    let _formItemTypeModified = formItemType;

    if (appDataDocuments?.[key]) {
      _propOptions = listHelpers.listStatic(appDataDocuments?.[key])
      _formItemTypeModified = gEnums.formItemTypes.dropdown
    }

    let _view = getActualView(view_ss, allGroups, appDataDocuments)

    if (!_propOptions) {

      // switch (formItemType) {

      //   case gEnums.formItemTypes.select:
      //   case gEnums.formItemTypes.dropdown:
      //   case gEnums.formItemTypes.dropdownAdd:
      //   case gEnums.formItemTypes.listSelect:

      // if the listType matches one of the listTypes, use that.
      if (listTypes[listType] && (gEnums[listType])) {
        _propOptions = listHelpers.listList(gEnums[listType])
      } else {

        switch (listType) {

          case dynListTypes.activePropList:
            // get the props from the current view
            // formItemType = gEnums.formItemTypes.dropdown 
            if (aps_viewItems?.[_view]) {
              _propOptions = listHelpers.listListO(aps_viewItems?.[_view]?.props)

              switch (prop) {
                case 'uniqueProps':
                  _formItemTypeModified = gEnums.formItemTypes.dropdown
              }
            }
            break;

          case dynListTypes.activePropsList:
            _propOptions = currentViPropList ? listHelpers.listListO(currentViPropList) : null
            if (currentViProps) {
              _propOptions = listHelpers.listSimple(currentViProps)
            }
            break;

          case dynListTypes.activeViPropList:
            if (data_localForm && listFrom && data_localForm[listFrom]) {
              const listFromValue = data_localForm[listFrom]
              if (appDataDocuments?.[listFromValue]) {
                const addValue = appDataDocuments[listFromValue]
                _propOptions = listHelpers.listStatic(addValue)
              }
            }
            break;

          case dynListTypes.activeAppUserViewProps:
            const _props_appUser = props_appUser ? { ...props_appUser } : {}
            Object.keys(_props_appUser).forEach(key => {
              if (key.startsWith('_')) { delete _props_appUser[key] }
            })
            _propOptions = listHelpers.listListO(_props_appUser)
            break;


          case dynListTypes.allPropList:
            _propOptions = listHelpers.listList(allPropsList)
            break;

          case dynListTypes.activeViList:
            _propOptions = listHelpers.listList(viewItemsList)
            break;

          case dynListTypes.activeViPropList2:
            if (localData && listFrom && localData[listFrom]) {
              const listFromValue = localData[listFrom]
              if (appDataDocuments?.[listFromValue]) {
                const staticValues = appDataDocuments[listFromValue]
                _propOptions = listHelpers.listStatic(staticValues)
              }
            }
            break;

          case dynListTypes.activeStaticViewsList:
            if (staticListProp_data && appDataDocuments && appDataDocuments[staticList]) {
              _propOptions = listHelpers.listStatic(appDataDocuments[staticList])
            } else {
              _propOptions = listHelpers.listListO(appDataDocuments)
            }
            break;

          case dynListTypes.appUserViewTypeProps:
            if (appDataDocuments && appDataDocuments[appUserViewTypeProp]) {
              _propOptions = listHelpers.listStatic(appDataDocuments[appUserViewTypeProp], appUserViewTypeProp)
            }
            break;

          case dynListTypes.activeCollectionPropList:
            _propOptions = currentCollectionPropList ? listHelpers.listListO(currentCollectionPropList) : null
            break;

          case listTypes.manifestSizes:
            _propOptions = listList(manifestSizes);
            break;

          case listTypes.settingGroupTypes:
            _propOptions = listList(gEnums.settingsMenuGroupTypes, true);
            break;

          case listTypes.roundTypes:
            _propOptions = listList(gEnums.roundTypes, true);
            break;

          case listTypes.timeZones:
            _propOptions = listList(_timeZones, true);
            break;

          case listTypes.appFormTypes:
            _propOptions = listHelpers.listList(appFormTypes)
            break;

          case listTypes.appUserFormTypes:
            _propOptions = listHelpers.listList(appUserFormTypes)
            break;

          case listTypes.appNames:
            _propOptions = listHelpers.listList(isDeveloper ? _projectAppNames : _projectAppNamesNonDev)
            break;

          case listTypes.notificationDeliveryTypes:
            const { appNotifications } = aps_global ?? {}
            const { allowPushNotifications, allowSmsNotifications, allowEmailNotifications } = appNotifications ?? {}
            if (listTypes[listType] && gEnums[listType]) {
              const ndtList = gEnums[listType]
              if (!allowPushNotifications) { delete ndtList.push }
              if (!allowSmsNotifications) { delete ndtList.sms }
              if (!allowEmailNotifications) { delete ndtList.email }
              _propOptions = createItemList(ndtList)
            }
            break;

          case dynListTypes.activeComponentList:
            _propOptions = listHelpers.listListI(componentContent)
            break;

          case dynListTypes.activeViListPlusClient:
            _propOptions = listHelpers.listList(c.sort())
            break;

          default:
        }
      }

      switch (key) {
        case 'active':
          _propOptions = listHelpers.listListO(gEnums.trueFalse)
          break;
        case 'year':
        case 'latestSeason':
          _propOptions = listHelpers.listYears()
          break;
        case 'state':
          _propOptions = listHelpers.listStates()
          break;
        default:
          break;
      }

      if (!_propOptions && showLogs) {
        console.log('missing prop options', listType, itemProp)
      }
      // break;
      // default:
      // console.log('formItemType', formItemType)
      // }
    }

    return { propOptions: _propOptions, formItemTypeModified: _formItemTypeModified }

  }, [])

  return { dynOptions, getDynOption }

}

const ammendFormItemType = (itemProp) => {

  if (!itemProp.data) { itemProp.data = {} }

  const { data, prop, key } = itemProp ?? {}
  const { formItemType } = data ?? {}
  const truePropKey = key || prop

  let _formItemType = formItemType

  const tpklc = _.isString(truePropKey) ? truePropKey.toLowerCase() : truePropKey

  if (tpklc.endsWith('active')) {
    _formItemType = gEnums.formItemTypes.checkbox
    itemProp.data.formItemType = gEnums.formItemTypes.checkbox
  }

  if (tpklc.indexOf('date') >= 0 &&
    tpklc.endsWith('date') &&
    !tpklc.endsWith('update') &&
    tpklc.indexOf('format') < 0 &&
    tpklc.indexOf('menus') < 0 &&
    tpklc.indexOf('horizontalIsDate') < 0) {
    _formItemType = gEnums.formItemTypes.date
  }

  if (tpklc.endsWith('year') || tpklc.endsWith('latestseason')) {
    _formItemType = gEnums.formItemTypes.year
    itemProp.data.formItemType = gEnums.formItemTypes.select
  }

  if (tpklc.indexOf('phonenumber') >= 0 && !_phoneExceptions.includes(truePropKey)) {
    _formItemType = gEnums.formItemTypes.phoneNumber
  }

  data.formItemType = _formItemType

}

const createItemList = (list) => {
  if (_.isEmpty(list)) return [];

  // 🔹 If it's an array: simple mapping
  if (_.isArray(list)) {
    return _.map(list, (key) => ({
      text: _.startCase(key),
      value: key,
      key,
    }));
  }

  // 🔹 If it's an object: map over its entries
  return _.map(list, (val, key) => {
    const hasCaption = _.has(val, "caption");
    return {
      text: hasCaption ? val.caption : _.startCase(key),
      value: hasCaption ? val.value ?? key : key,
      key: hasCaption ? val.key ?? key : key,
    };
  });
};

const getActualView = (view, allGroups, appDataDocuments) => {
  const lastGroup_1 = allGroups ? allGroups?.[allGroups.length - 1] : {}
  const { parentGroupKey: parentGroupKey_1 } = lastGroup_1 ?? {}
  const lastGroup_2 = allGroups ? allGroups?.[allGroups.length - 2] : {}
  const { parentGroupKey: parentGroupKey_2 } = lastGroup_2 ?? {}

  let _view = view

  if (appDataDocuments?.[parentGroupKey_1]) {
    _view = parentGroupKey_1
  }

  if (appDataDocuments?.[parentGroupKey_2]) {
    _view = parentGroupKey_2
  }

  return _view

}